module.exports = __webpack_public_path__ + "static/media/forbidden-banner.e0fb8816.svg";